
export const ERROR_400 = 400
export const ERROR_401 = 401
export const ERROR_403 = 403
export const ERROR_404 = 404
export const ERROR_500 = 500
export const ERROR_502 = 502
export const ERROR_503 = 503
export const ERROR_RENDER = 'render'
export const ERROR_CLIENT = 'client'


interface Returned {
  code: number | string;
  label: string;
  message: string;
}

export const getErrorResponse = (errorCode: string | number = 500): Returned => {
  const parsedErrorCode = Number.isNaN(+errorCode) ? errorCode : +errorCode
  const code = parsedErrorCode
  let label = ''
  let message = ''

  switch (parsedErrorCode) {
    case ERROR_400:
      label = 'Неверный запрос'
      break

    case ERROR_401:
      label = 'Не авторизован'
      break

    case ERROR_403:
      label = 'У вас недостаточно прав для совершения данной операции'
      message = 'У вас нет прав для совершения данной операции. Проверьте свои права в таблице групп'
      break

    case ERROR_404:
      label = 'Страница не найдена'
      message = 'Извините, страницу которую вы искали, не найдена'
      break

    case ERROR_500:
      label = 'Во время выполнения операции произошла ошибка. В случае повторения ошибки обратитесь в техподдержку'
      break

    case ERROR_502:
    case ERROR_503:
      label = 'Сервис временно недоступен. В случае повторения ошибки обратитесь в техподдержку'
      break

    case ERROR_RENDER:
      label = 'Произошла ошибка и мы не можем отрисовать некоторые элементы страницы'
      break

    case ERROR_CLIENT:
      label = 'Возникла ошибка на стороне клиента'
      break

    default:
      if (errorCode.toString().startsWith('4')) {
        return getErrorResponse(ERROR_400)
      }

      return getErrorResponse(ERROR_500)
  }

  return { code, label, message }
}
